/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    AllaccountDetails {
      email
      id
      fullName
      createdAt
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
